import type { Movie } from "@/types";

export const genreList = [
  "剧情",
  "动作",
  "科幻",
  "喜剧",
  "爱情",
  "恐怖",
  "犯罪",
  "冒险",
  "战争",
  "家庭",
  "惊悚",
  "悬疑",
  "奇幻",
];

export const regionList = ["欧美", "亚洲", "其他"];

export const yearRanges = [
  { label: "1980-1983", min: 1980, max: 1983 },
  { label: "1984-1986", min: 1984, max: 1986 },
  { label: "1987-1989", min: 1987, max: 1989 },
];

export const movies: Movie[] = [
  {
    id: "back-to-the-future-1985",
    title: "回到未来",
    originalTitle: "Back to the Future",
    year: 1985,
    genres: ["科幻", "喜剧", "冒险"],
    region: "欧美",
    director: "罗伯特·泽米吉斯",
    cast: ["迈克尔·J·福克斯", "克里斯托弗·洛伊德", "莉·汤普森"],
    runtime: 116,
    rating: 8.9,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20science%20fiction%20film%20poster%20illustration%20of%20a%20gleaming%20silver%20sports%20car%20with%20glowing%20blue%20energy%20trails%20against%20a%20starry%20purple%20sky%2C%20vintage%20film%20grain%20texture%2C%20deep%20teal%20and%20burnt%20orange%20accents%2C%20geometric%20cinematic%20composition%2C%20high%20detail%2C%20no%20text%20no%20letters%20no%20words&width=600&height=900&seq=mv-bttf-1985&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20retro%201980s%20scene%20of%20a%20silver%20sports%20car%20with%20glowing%20blue%20energy%20trails%20streaking%20across%20a%20starry%20night%20sky%2C%20vintage%20film%20grain%2C%20deep%20teal%20and%20burnt%20orange%20tones%2C%20dramatic%20lighting%2C%20artistic%20illustration%2C%20no%20text%20no%20words&width=1920&height=1080&seq=bd-bttf-1985&orientation=landscape",
    tagline: "时间机器就在这台车上，而它的燃料是闪电。",
    summary: "高中生马蒂意外被挚友发明的时光车送回1955年，必须在改变历史之前找到回家的方法。",
    synopsis:
      "1985年，热爱摇滚的高中生马丁·麦克弗莱与古怪的科学家布朗博士交好。一夜之间，布朗博士发明的德罗宁时光车被启动，马丁被意外送回了30年前的1955年。在这个陌生的年代，他不仅遇见了年轻时的父母，还因为一次善意的相助打乱了他们本该相识相爱的命运。为了让历史重回正轨，也为了借助闪电的能量回到未来，马丁必须与年轻的布朗博士联手完成一场跨越时空的冒险。",
    reviews: [
      {
        id: "r-bttf-1",
        author: "银幕考古者",
        rating: 5,
        text: "把科幻、青春与家庭喜剧揉成一枚完美的时代胶囊。节奏轻盈到不可思议，每一次回看都还是忍不住微笑。",
        date: "2024-03-12",
      },
      {
        id: "r-bttf-2",
        author: "老放映厅",
        rating: 4.5,
        text: "德罗宁跑车、悬浮滑板、钟楼闪电——它定义了整整一代人对时间的浪漫想象。",
        date: "2023-11-02",
      },
    ],
  },
  {
    id: "blade-runner-1982",
    title: "银翼杀手",
    originalTitle: "Blade Runner",
    year: 1982,
    genres: ["科幻", "惊悚", "悬疑"],
    region: "欧美",
    director: "雷德利·斯科特",
    cast: ["哈里森·福特", "鲁特格尔·哈尔", "肖恩·杨"],
    runtime: 117,
    rating: 8.1,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%20cyberpunk%20science%20fiction%20film%20poster%20illustration%20of%20a%20rainy%20neon%20cityscape%20with%20towering%20buildings%20and%20glowing%20amber%20lights%20reflecting%20on%20wet%20streets%2C%20vintage%20film%20grain%20texture%2C%20deep%20teal%20and%20burnt%20orange%20palette%2C%20geometric%20cinematic%20composition%2C%20high%20detail%2C%20no%20text%20no%20letters%20no%20words&width=600&height=900&seq=mv-bladerunner-1982&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20retro%20cyberpunk%20cityscape%20at%20night%20with%20neon%20signs%2C%20rain%20and%20steam%2C%20towering%20dark%20towers%2C%20amber%20and%20teal%20lighting%2C%20vintage%20film%20grain%2C%20artistic%20illustration%2C%20moody%20atmosphere%2C%20no%20text%20no%20words&width=1920&height=1080&seq=bd-bladerunner-1982&orientation=landscape",
    tagline: "在雨中，仿生人梦见电子羊。",
    summary: "在雨雾笼罩的洛杉矶，一名专门猎杀仿生人的银翼杀手开始质疑自己与人造的边界。",
    synopsis:
      "2019年的洛杉矶被永不停歇的酸雨笼罩，人类制造出与真人无异的仿生人用于外星星球劳作。当几名仿生人潜回地球寻求延长寿命的方法，资深银翼杀手里克·戴克被派去将他们清除。在追踪过程中，戴克遇见了仿生人蕾切尔，并逐渐被这群被称作“复制人”的存在所触动。当最后的仿生人罗伊在雨中说出那番独白，关于生命、记忆与人性的疑问被永远留在了观众心中。",
    reviews: [
      {
        id: "r-br-1",
        author: "霓虹收集者",
        rating: 5,
        text: "视觉与哲思的巅峰。每一帧都像一幅湿润的油画，而那句雨中独白足以封神。",
        date: "2024-05-20",
      },
      {
        id: "r-br-2",
        author: "旧磁带",
        rating: 4,
        text: "当年票房失利，如今回看却是科幻美学的源头。慢，但每一秒都值得。",
        date: "2023-09-08",
      },
    ],
  },
  {
    id: "the-terminator-1984",
    title: "终结者",
    originalTitle: "The Terminator",
    year: 1984,
    genres: ["科幻", "动作", "惊悚"],
    region: "欧美",
    director: "詹姆斯·卡梅隆",
    cast: ["阿诺·施瓦辛格", "琳达·汉密尔顿", "迈克尔·比恩"],
    runtime: 107,
    rating: 8.1,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20science%20fiction%20action%20film%20poster%20illustration%20of%20a%20lone%20silhouetted%20figure%20in%20a%20leather%20jacket%20standing%20before%20a%20glowing%20red%20skull%20and%20embers%2C%20vintage%20film%20grain%20texture%2C%20deep%20teal%20and%20burnt%20orange%20palette%2C%20geometric%20cinematic%20composition%2C%20high%20detail%2C%20no%20text%20no%20letters%20no%20words&width=600&height=900&seq=mv-terminator-1984&orientation=portrait",
    tagline: "来自未来的杀手，目标只有一个。",
    summary: "来自未来的机械杀手穿越回1984年，企图杀死未来人类抵抗军领袖的母亲。",
    synopsis:
      "在核战后的未来，人工智能“天网”派出名为终结者的几乎无法摧毁的机械杀手，穿越回到1984年的洛杉矶，意图杀死一位普通女服务员莎拉·康纳——她尚未出生的儿子将成为人类抵抗军的领袖。与此同时，人类抵抗军也派出一名战士凯尔·里斯回到过去保护她。一场你追我赶的生死较量就此展开，命运的齿轮在枪火与废墟中缓缓转动。",
    reviews: [
      {
        id: "r-tm-1",
        author: "夜行快车",
        rating: 5,
        text: "低成本却拍出了压迫感十足的末日惊悚。施瓦辛格站在那里就是威胁本身。",
        date: "2024-02-14",
      },
      {
        id: "r-tm-2",
        author: "电影拾荒者",
        rating: 4,
        text: "卡梅隆把B级片的骨架练成了A级的肌肉，节奏至今仍不过时。",
        date: "2023-07-21",
      },
    ],
  },
  {
    id: "e-t-1982",
    title: "E.T.外星人",
    originalTitle: "E.T. the Extra-Terrestrial",
    year: 1982,
    genres: ["科幻", "家庭", "冒险"],
    region: "欧美",
    director: "史蒂文·斯皮尔伯格",
    cast: ["亨利·托马斯", "德鲁·巴里摩尔", "迪·沃伦斯"],
    runtime: 115,
    rating: 8.3,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20family%20science%20fiction%20film%20poster%20illustration%20of%20a%20boy%20and%20a%20small%20glowing%20alien%20silhouetted%20against%20a%20huge%20warm%20moon%20over%20a%20pine%20forest%2C%20vintage%20film%20grain%20texture%2C%20deep%20teal%20and%20burnt%20orange%20palette%2C%20geometric%20cinematic%20composition%2C%20high%20detail%2C%20no%20text%20no%20letters%20no%20words&width=600&height=900&seq=mv-et-1982&orientation=portrait",
    tagline: "他只想回家。",
    summary: "一个孤独的男孩与一个被困地球的外星人成为朋友，并帮助他寻找回家的路。",
    synopsis:
      "一艘外星飞船造访地球后匆匆离去，把一个同伴遗落在了加州郊外的森林里。孤独的男孩艾略特发现了这个友善的小外星人，并把他藏在家中，取名为E.T.。两人之间建立起一种奇妙的心灵联结，艾略特也第一次感到不再孤单。然而大人们的追踪与E.T.日益衰弱的身体，让这场告别变得迫在眉睫。孩子们骑上自行车飞向夜空的那一幕，成为了一代人关于友谊与奇迹的集体记忆。",
    reviews: [
      {
        id: "r-et-1",
        author: "童年放映机",
        rating: 5,
        text: "关于孤独与友谊最纯净的科幻童话。自行车飞过月亮时，谁都会心软。",
        date: "2024-04-01",
      },
      {
        id: "r-et-2",
        author: "夏夜萤火",
        rating: 4.5,
        text: "斯皮尔伯格把孩子的孤独拍得那么真实，又把奇迹拍得那么自然。",
        date: "2023-10-19",
      },
    ],
  },
  {
    id: "die-hard-1988",
    title: "虎胆龙威",
    originalTitle: "Die Hard",
    year: 1988,
    genres: ["动作", "惊悚", "犯罪"],
    region: "欧美",
    director: "约翰·麦克蒂尔南",
    cast: ["布鲁斯·威利斯", "艾伦·瑞克曼", "邦妮·比蒂丽娅"],
    runtime: 132,
    rating: 8.2,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20action%20thriller%20film%20poster%20illustration%20of%20a%20tall%20glass%20skyscraper%20at%20night%20with%20one%20window%20glowing%20amber%20and%20smoke%20rising%2C%20vintage%20film%20grain%20texture%2C%20deep%20teal%20and%20burnt%20orange%20palette%2C%20geometric%20cinematic%20composition%2C%20high%20detail%2C%20no%20text%20no%20letters%20no%20words&width=600&height=900&seq=mv-diehard-1988&orientation=portrait",
    tagline: "平安夜，一栋大楼，一个不肯退让的警察。",
    summary: "平安夜，一名纽约警察在洛杉矶高楼里独自对抗一伙劫持人质的悍匪。",
    synopsis:
      "纽约警察约翰·麦卡伦飞到洛杉矶，只为与分居的妻子共度圣诞。当他来到妻子任职的日商大厦参加晚会时，大楼却被一伙训练有素的劫匪占领，宾客悉数成为人质，保险柜里的巨额债券成了他们的目标。仅凭一把手枪和一腔倔强的麦卡伦，在整栋大楼里与匪首汉斯·格鲁伯展开了一场孤独的周旋，用玻璃、通风管和赤脚一步一步瓦解对方的计划。",
    reviews: [
      {
        id: "r-dh-1",
        author: "动作胶片",
        rating: 5,
        text: "现代动作片的教科书。一个会受伤、会害怕、会自言自语的主角，反而无所不能。",
        date: "2024-06-11",
      },
      {
        id: "r-dh-2",
        author: "爆米花档案",
        rating: 4.5,
        text: "艾伦·瑞克曼的反派优雅得让人恨不起来，跟布鲁斯的粗粝形成绝妙对照。",
        date: "2023-12-25",
      },
    ],
  },
  {
    id: "ghostbusters-1984",
    title: "捉鬼敢死队",
    originalTitle: "Ghostbusters",
    year: 1984,
    genres: ["喜剧", "奇幻", "科幻"],
    region: "欧美",
    director: "伊万·雷特曼",
    cast: ["比尔·默瑞", "丹·艾克罗伊德", "西格妮·韦弗"],
    runtime: 105,
    rating: 7.8,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20comedy%20supernatural%20film%20poster%20illustration%20of%20a%20friendly%20glowing%20green%20ghost%20floating%20above%20a%20city%20skyline%2C%20playful%20spooky%20mood%2C%20vintage%20film%20grain%20texture%2C%20deep%20teal%20and%20burnt%20orange%20palette%2C%20geometric%20cinematic%20composition%2C%20high%20detail%2C%20no%20text%20no%20letters%20no%20words&width=600&height=900&seq=mv-ghostbusters-1984&orientation=portrait",
    tagline: "谁在召唤？我们来处理。",
    summary: "三位被解雇的教授成立捉鬼公司，用科学仪器捕捉泛滥全城的幽灵。",
    synopsis:
      "三位研究超自然现象的哥伦比亚大学学者在被学校解雇后，索性成立了一家名为“捉鬼敢死队”的公司，专门上门处理城里越来越频繁的闹鬼事件。他们背着质子背包、开着改装的救护车，一时间成为纽约的红人。然而当一位神秘女子前来求助，事情逐渐升级为一场关乎整座城市的超自然危机。喜剧、特效与流行文化在此刻完美合体。",
    reviews: [
      {
        id: "r-gb-1",
        author: "录像带一代",
        rating: 4.5,
        text: "把恐怖片的设定拿来搞笑，还顺手定义了80年代的流行符号。米其林宝宝谁不爱。",
        date: "2024-01-30",
      },
      {
        id: "r-gb-2",
        author: "午夜频道",
        rating: 4,
        text: "幽默、怪兽、主题曲三位一体，是那种随便打开一段都能看下去的电影。",
        date: "2023-08-15",
      },
    ],
  },
  {
    id: "the-breakfast-club-1985",
    title: "早餐俱乐部",
    originalTitle: "The Breakfast Club",
    year: 1985,
    genres: ["剧情", "喜剧"],
    region: "欧美",
    director: "约翰·休斯",
    cast: ["埃米利奥·埃斯特维兹", "莫利·林沃德", "贾德·尼尔森"],
    runtime: 97,
    rating: 7.8,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20teen%20drama%20film%20poster%20illustration%20of%20five%20teenagers%20in%20silhouette%20standing%20on%20empty%20school%20stairs%2C%20warm%20sunset%20light%2C%20vintage%20film%20grain%20texture%2C%20deep%20teal%20and%20burnt%20orange%20palette%2C%20geometric%20cinematic%20composition%2C%20high%20detail%2C%20no%20text%20no%20letters%20no%20words&width=600&height=900&seq=mv-breakfastclub-1985&orientation=portrait",
    tagline: "五个陌生人，一个下午，各自的心事。",
    summary: "五个性格迥异的高中生被罚在周六留校，在一天里撕下彼此的标签。",
    synopsis:
      "一个周六的早晨，五位来自不同圈子、彼此看不顺眼的高中生因为各自的原因被罚留校。一个是运动明星，一个是书呆子，一个是叛逆少女，一个是怪咖，还有一个是乖巧的好学生。在漫长而空荡的图书馆里，他们先是互相嘲笑与对抗，随后却慢慢卸下伪装，聊起各自家庭与内心的疼痛。当这一天结束，他们发现彼此远比标签更复杂，也更相似。",
    reviews: [
      {
        id: "r-bc-1",
        author: "青春片研究者",
        rating: 4.5,
        text: "几乎全在一个房间里完成，却比任何大场面都更贴近青春的本质。台词精彩到可以背下来。",
        date: "2024-03-22",
      },
      {
        id: "r-bc-2",
        author: "课桌涂鸦",
        rating: 4,
        text: "它讲的不是叛逆，而是被误解。结尾那记挥拳头礼，是和解也是宣言。",
        date: "2023-06-30",
      },
    ],
  },
  {
    id: "top-gun-1986",
    title: "壮志凌云",
    originalTitle: "Top Gun",
    year: 1986,
    genres: ["动作", "剧情", "爱情"],
    region: "欧美",
    director: "托尼·斯科特",
    cast: ["汤姆·克鲁斯", "凯莉·麦吉利斯", "瓦尔·基尔默"],
    runtime: 110,
    rating: 7.1,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20action%20aviation%20film%20poster%20illustration%20of%20a%20fighter%20jet%20climbing%20through%20a%20golden%20sunset%20sky%20with%20contrails%2C%20warm%20orange%20glow%2C%20vintage%20film%20grain%20texture%2C%20deep%20teal%20and%20burnt%20orange%20palette%2C%20geometric%20cinematic%20composition%2C%20high%20detail%2C%20no%20text%20no%20letters%20no%20words&width=600&height=900&seq=mv-topgun-1986&orientation=portrait",
    tagline: "感受速度，也感受代价。",
    summary: "天才飞行员进入精英飞行学校，在速度、荣耀与失去中寻找真正的自我。",
    synopsis:
      "桀骜不驯的海军飞行员皮特·米切尔被选入顶尖的“壮志凌云”飞行学校，与一群同样出色的王牌同僚展开角逐。他凭着一股直觉与胆识在空中所向披靡，却也因为冒险的性格付出了沉重的代价。在爱情与战友之情的交错中，他必须直面心中的恐惧，学会什么是真正的责任与信任，然后重新回到属于他的天空。",
    reviews: [
      {
        id: "r-tg-1",
        author: "无线电频道",
        rating: 4,
        text: "空战戏至今看依旧热血沸腾，配乐一响整个人都坐直了。青春与速度的最好代言。",
        date: "2024-05-05",
      },
      {
        id: "r-tg-2",
        author: "夕阳跑道",
        rating: 3.5,
        text: "剧情略显直白，但那种荷尔蒙与阳光的味道，是80年代独一份的浪漫。",
        date: "2023-11-28",
      },
    ],
  },
  {
    id: "aliens-1986",
    title: "异形2",
    originalTitle: "Aliens",
    year: 1986,
    genres: ["科幻", "动作", "恐怖"],
    region: "欧美",
    director: "詹姆斯·卡梅隆",
    cast: ["西格妮·韦弗", "迈克尔·比恩", "凯莉·赫恩"],
    runtime: 137,
    rating: 8.4,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20science%20fiction%20horror%20film%20poster%20illustration%20of%20a%20glowing%20xenomorph%20silhouette%20looming%20over%20an%20industrial%20space%20colony%20with%20red%20emergency%20lights%2C%20vintage%20film%20grain%20texture%2C%20deep%20teal%20and%20burnt%20orange%20palette%2C%20geometric%20cinematic%20composition%2C%20high%20detail%2C%20no%20text%20no%20letters%20no%20words&width=600&height=900&seq=mv-aliens-1986&orientation=portrait",
    tagline: "这一次，它们不只一个。",
    summary: "唯一的幸存者随海军陆战队重返异形巢穴，展开一场母性与杀戮的较量。",
    synopsis:
      "在异形事件中唯一幸存的女军官蕾普莉，在漂流了57年后被救回。当她得知人类殖民地已在那颗星球上失去联络，便随一支全副武装的海军陆战队重返现场。等待他们的不是殖民者，而是成群结队的异形。当小队一个接一个倒下，蕾普莉为了保护一个小女孩纽特，与异形女王展开了一场关于母性、生存与意志的正面对决。",
    reviews: [
      {
        id: "r-al-1",
        author: "深空信号",
        rating: 5,
        text: "把惊悚升级成战争片，又把战争片升华成母性史诗。蕾普莉是影史最硬核的女主角之一。",
        date: "2024-04-18",
      },
      {
        id: "r-al-2",
        author: "气压舱",
        rating: 4.5,
        text: "卡梅隆对节奏的掌控炉火纯青，最后那句台词让人起鸡皮疙瘩。",
        date: "2023-09-25",
      },
    ],
  },
  {
    id: "the-shining-1980",
    title: "闪灵",
    originalTitle: "The Shining",
    year: 1980,
    genres: ["恐怖", "悬疑", "惊悚"],
    region: "欧美",
    director: "斯坦利·库布里克",
    cast: ["杰克·尼科尔森", "谢莉·杜瓦尔", "丹尼·劳埃德"],
    runtime: 146,
    rating: 8.2,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20psychological%20horror%20film%20poster%20illustration%20of%20a%20massive%20empty%20hotel%20corridor%20with%20harsh%20geometric%20carpet%20and%20a%20distant%20glowing%20doorway%2C%20eerie%20mood%2C%20vintage%20film%20grain%20texture%2C%20deep%20teal%20and%20burnt%20orange%20palette%2C%20cinematic%20composition%2C%20high%20detail%2C%20no%20text%20no%20letters%20no%20words&width=600&height=900&seq=mv-shining-1980&orientation=portrait",
    tagline: "这家旅馆，一直在等待。",
    summary: "一位作家带着妻儿看守冬季封闭的旅馆，孤独与超自然力量逐渐将他逼疯。",
    synopsis:
      "作家杰克·托兰斯为了寻找创作灵感，接受了冬季看守一座雪山旅馆的工作，带着妻子温蒂和拥有“闪灵”感应能力的儿子丹尼住进了空无一人的酒店。随着大雪封路、与世隔绝的日子不断延长，旅馆里潜伏的诡异力量开始侵扰每一个人。杰克的理智一点点崩塌，而丹尼感应到的恐怖画面也愈来愈清晰。这座看似典雅的旅馆，藏着一个不愿被遗忘的秘密。",
    reviews: [
      {
        id: "r-sh-1",
        author: "走廊尽头",
        rating: 5,
        text: "每一处对称构图都在制造不安。它不靠吓人，而是让你从骨子里发冷。",
        date: "2024-02-02",
      },
      {
        id: "r-sh-2",
        author: "红门观察员",
        rating: 4.5,
        text: "尼科尔森的表演是一场缓慢的爆炸。库布里克把空间本身变成了反派。",
        date: "2023-10-31",
      },
    ],
  },
  {
    id: "scarface-1983",
    title: "疤面煞星",
    originalTitle: "Scarface",
    year: 1983,
    genres: ["犯罪", "剧情"],
    region: "欧美",
    director: "布莱恩·德·帕尔玛",
    cast: ["阿尔·帕西诺", "米歇尔·菲佛", "斯蒂文·鲍尔"],
    runtime: 170,
    rating: 8.3,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20crime%20drama%20film%20poster%20illustration%20of%20a%20miami%20skyline%20at%20dusk%20with%20palm%20trees%20and%20a%20glowing%20amber%20sun%2C%20dark%20noir%20mood%2C%20vintage%20film%20grain%20texture%2C%20deep%20teal%20and%20burnt%20orange%20palette%2C%20geometric%20cinematic%20composition%2C%20high%20detail%2C%20no%20text%20no%20letters%20no%20words&width=600&height=900&seq=mv-scarface-1983&orientation=portrait",
    tagline: "世界属于你，直到你不小心拥有得太多。",
    summary: "一名古巴难民在迈阿密从街头小卒一路爬上毒枭王座，最终被野心吞噬。",
    synopsis:
      "古巴难民托尼·蒙塔纳来到迈阿密，从洗碗工做起，凭借狠辣与野心迅速在毒品交易中崭露头角。他一步步吞并对手，建立起自己的帝国，把整座城市的白色粉末都踩在脚下。金钱、权力与美人接踵而至，然而疑心与贪婪也在他心底疯狂生长。当他站在豪宅的顶端俯瞰世界时，脚下那座摇摇欲坠的王国，正等着在枪火中崩塌。",
    reviews: [
      {
        id: "r-sf-1",
        author: "霓虹迈阿密",
        rating: 5,
        text: "帕西诺把野心演到了极致。那句关于世界的台词，是无数人的座右铭也是诅咒。",
        date: "2024-06-06",
      },
      {
        id: "r-sf-2",
        author: "白色粉末档案",
        rating: 4,
        text: "更愿意把它读成一个关于贪婪的警世寓言。浮华背后，全是深渊。",
        date: "2023-07-07",
      },
    ],
  },
  {
    id: "raiders-of-the-lost-ark-1981",
    title: "夺宝奇兵",
    originalTitle: "Raiders of the Lost Ark",
    year: 1981,
    genres: ["冒险", "动作"],
    region: "欧美",
    director: "史蒂文·斯皮尔伯格",
    cast: ["哈里森·福特", "凯伦·阿兰", "保罗·弗里曼"],
    runtime: 115,
    rating: 8.6,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20adventure%20film%20poster%20illustration%20of%20a%20rugged%20explorer%20silhouette%20crossing%20an%20ancient%20desert%20temple%20with%20glowing%20golden%20treasure%20and%20torchlight%2C%20vintage%20film%20grain%20texture%2C%20deep%20teal%20and%20burnt%20orange%20palette%2C%20geometric%20cinematic%20composition%2C%20high%20detail%2C%20no%20text%20no%20letters%20no%20words&width=600&height=900&seq=mv-raiders-1981&orientation=portrait",
    tagline: "宝藏属于勇敢者，也属于跑得够快的人。",
    summary: "考古学家印第安纳·琼斯在全球追夺失落的圣物，与纳粹展开一场惊险竞速。",
    synopsis:
      "考古学教授印第安纳·琼斯有着双重身份——课堂上的学者与探险路上的寻宝者。当军方找到他，希望他抢在纳粹之前找到传说中的约柜时，一场横跨沙漠、古庙与潜艇的冒险就此展开。鞭子、皮鞭帽与不羁的笑容成了他的招牌。他要面对毒蛇、陷阱和旧日恋人玛丽昂，也要在时间耗尽之前，阻止一件圣物落入错误的双手。",
    reviews: [
      {
        id: "r-rd-1",
        author: "藏宝图收藏家",
        rating: 5,
        text: "冒险片的黄金标准。每一场追逐都让人喘不过气，幽默与危险配比得恰到好处。",
        date: "2024-03-03",
      },
      {
        id: "r-rd-2",
        author: "沙尘与皮鞭",
        rating: 4.5,
        text: "哈里森·福特塑造了一个永远会挨打、也永远会爬起来的英雄。童年最爱的一个人。",
        date: "2023-08-08",
      },
    ],
  },
  {
    id: "ferris-bueller-1986",
    title: "春天不是读书天",
    originalTitle: "Ferris Bueller's Day Off",
    year: 1986,
    genres: ["喜剧", "剧情"],
    region: "欧美",
    director: "约翰·休斯",
    cast: ["马修·布罗德里克", "阿兰·鲁克", "米娅·萨拉"],
    runtime: 103,
    rating: 7.8,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20teen%20comedy%20film%20poster%20illustration%20of%20a%20carefree%20teenager%20silhouette%20dancing%20on%20a%20sunny%20city%20street%20with%20a%20red%20sports%20car%2C%20playful%20mood%2C%20vintage%20film%20grain%20texture%2C%20deep%20teal%20and%20burnt%20orange%20palette%2C%20geometric%20cinematic%20composition%2C%20high%20detail%2C%20no%20text%20no%20letters%20no%20words&width=600&height=900&seq=mv-ferris-1986&orientation=portrait",
    tagline: "生活过得快，如果你不偶尔停下来看看。",
    summary: "一个高中生装病逃课，带着好友和女友把平凡的一天过成了传奇。",
    synopsis:
      "深受同学喜爱的高中生费里斯，决定用一场精心设计的“生病”来逃掉一天的课。他说服了好友卡梅伦，又“借”来了卡梅伦父亲视若珍宝的跑车，带上女友斯隆，在城市里展开了一场说走就走的冒险。看球赛、逛博物馆、参加游行，还有那场著名的花车演出。而被留在学校里的校长，则誓要揭穿他的谎言。轻松、叛逆、又带着一点青春独有的伤感。",
    reviews: [
      {
        id: "r-fb-1",
        author: "逃课指南",
        rating: 4.5,
        text: "关于青春最好的宣言之一。它告诉你，有时候荒废一天，才是最不荒废的一天。",
        date: "2024-05-09",
      },
      {
        id: "r-fb-2",
        author: "博物馆台阶",
        rating: 4,
        text: "笑着笑着就有点难过。费里斯是自由的，而我们都当过卡梅伦。",
        date: "2023-11-11",
      },
    ],
  },
  {
    id: "when-harry-met-sally-1989",
    title: "当哈利遇到莎莉",
    originalTitle: "When Harry Met Sally...",
    year: 1989,
    genres: ["爱情", "喜剧"],
    region: "欧美",
    director: "罗伯·莱纳",
    cast: ["比利·克里斯托", "梅格·瑞安", "凯丽·费雪"],
    runtime: 96,
    rating: 7.7,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20romantic%20comedy%20film%20poster%20illustration%20of%20a%20man%20and%20woman%20silhouette%20walking%20in%20autumn%20central%20park%20with%20warm%20orange%20leaves%2C%20tender%20mood%2C%20vintage%20film%20grain%20texture%2C%20deep%20teal%20and%20burnt%20orange%20palette%2C%20geometric%20cinematic%20composition%2C%20high%20detail%2C%20no%20text%20no%20letters%20no%20words&width=600&height=900&seq=mv-harrysally-1989&orientation=portrait",
    tagline: "男女之间，真的不能做朋友吗？",
    summary: "两个观念相左的男女在十二年间反复相遇，终于承认了彼此的心意。",
    synopsis:
      "哈利与莎莉在一次拼车中相识，却因为对男女关系的看法截然不同而不欢而散。此后十二年里，他们在机场、书店和朋友的婚礼上不断重逢，从互相看不顺眼到成为无话不谈的朋友。他们分享各自的失恋与孤独，争论着“男人和女人能否只做朋友”。当友谊的边界被某个跨年的夜晚轻轻推开，两人才明白，有些答案需要用半生去寻找。",
    reviews: [
      {
        id: "r-ws-1",
        author: "跨年倒数",
        rating: 5,
        text: "爱情喜剧的天花板。聪明、幽默又真诚，最后那段奔跑告白至今无人能超越。",
        date: "2024-02-14",
      },
      {
        id: "r-ws-2",
        author: "书店角落",
        rating: 4.5,
        text: "它承认爱情的复杂，也相信爱情的美好。对白写得像爵士乐。",
        date: "2023-12-31",
      },
    ],
  },
  {
    id: "rain-man-1988",
    title: "雨人",
    originalTitle: "Rain Man",
    year: 1988,
    genres: ["剧情"],
    region: "欧美",
    director: "巴里·莱文森",
    cast: ["达斯汀·霍夫曼", "汤姆·克鲁斯", "瓦莱丽亚·戈利诺"],
    runtime: 133,
    rating: 8.0,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20road%20drama%20film%20poster%20illustration%20of%20two%20figures%20walking%20along%20an%20empty%20desert%20highway%20at%20golden%20hour%20with%20a%20vintage%20car%2C%20warm%20orange%20sky%2C%20vintage%20film%20grain%20texture%2C%20deep%20teal%20and%20burnt%20orange%20palette%2C%20geometric%20cinematic%20composition%2C%20high%20detail%2C%20no%20text%20no%20letters%20no%20words&width=600&height=900&seq=mv-rainman-1988&orientation=portrait",
    tagline: "一段旅程，两个兄弟，和一场迟到的理解。",
    summary: "自私的年轻人为了遗产找到患有自闭症的哥哥，却在旅途中学会了爱。",
    synopsis:
      "精明却冷漠的汽车商人查理，在父亲去世后发现自己被排除在遗产之外，唯一的受益人是自己从未听说过的哥哥雷蒙。雷蒙患有自闭症，却拥有惊人的记忆力与计算能力，一直生活在疗养院中。查理起初只想把哥哥“带回来”争夺财产，却在横跨美国的公路旅行中，被雷蒙固执而纯粹的世界慢慢改变。两个陌生人一般的兄弟，在公路上找回了失落的亲情。",
    reviews: [
      {
        id: "r-rm-1",
        author: "公路电影簿",
        rating: 4.5,
        text: "霍夫曼的表演令人心碎又温暖。它讲的不是天才，而是学着去理解另一个灵魂。",
        date: "2024-04-24",
      },
      {
        id: "r-rm-2",
        author: "路边旅馆",
        rating: 4,
        text: "克鲁斯证明了自己不只是偶像。结尾的分岔路口，比任何拥抱都更有力量。",
        date: "2023-10-10",
      },
    ],
  },
  {
    id: "a-better-tomorrow-1986",
    title: "英雄本色",
    originalTitle: "A Better Tomorrow",
    year: 1986,
    genres: ["犯罪", "动作", "剧情"],
    region: "亚洲",
    director: "吴宇森",
    cast: ["周润发", "狄龙", "张国荣"],
    runtime: 95,
    rating: 8.4,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20hong%20kong%20action%20film%20poster%20illustration%20of%20a%20man%20in%20a%20long%20windbreaker%20holding%20a%20gun%20with%20flying%20doves%20and%20glowing%20orange%20muzzle%20flash%2C%20rainy%20night%20mood%2C%20vintage%20film%20grain%20texture%2C%20deep%20teal%20and%20burnt%20orange%20palette%2C%20cinematic%20composition%2C%20high%20detail%2C%20no%20text%20no%20letters%20no%20words&width=600&height=900&seq=mv-abettertomorrow-1986&orientation=portrait",
    tagline: "情义，是江湖里最贵的奢侈品。",
    summary: "一对黑帮兄弟与昔日战友之间，关于情义、背叛与救赎的港式江湖史诗。",
    synopsis:
      "黑帮骨干宋子豪与好兄弟马克情同手足，却因一次交易失败，宋子豪锒铛入狱，马克也因替他复仇而跛了一条腿。出狱后，宋子豪只想洗心革面，做回一个普通人，却发现已成为警察的弟弟对他充满怨恨，而昔日的江湖也容不下他。当旧日的恩怨卷土重来，三个被命运绑在一起的男人，只能在枪火与血泊中，寻找那份属于彼此的情义与尊严。",
    reviews: [
      {
        id: "r-abt-1",
        author: "港片放映室",
        rating: 5,
        text: "周润发点烟的瞬间，一个时代就此点燃。慢镜头、白鸽与枪火，成了后来者的终生功课。",
        date: "2024-06-18",
      },
      {
        id: "r-abt-2",
        author: "夜色霓虹",
        rating: 4.5,
        text: "它讲的从来不是打打杀杀，而是情义二字有多重。看一次哭一次。",
        date: "2023-09-09",
      },
    ],
  },
  {
    id: "my-neighbor-totoro-1988",
    title: "龙猫",
    originalTitle: "My Neighbor Totoro",
    year: 1988,
    genres: ["奇幻", "家庭", "冒险"],
    region: "亚洲",
    director: "宫崎骏",
    cast: ["日高法子", "坂本千夏", "糸井重里"],
    runtime: 86,
    rating: 9.2,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20animated%20fantasy%20film%20poster%20illustration%20of%20two%20little%20girls%20standing%20beside%20a%20giant%20furry%20forest%20creature%20under%20a%20huge%20camphor%20tree%2C%20soft%20green%20and%20warm%20orange%20light%2C%20vintage%20film%20grain%20texture%2C%20deep%20teal%20and%20burnt%20orange%20palette%2C%20geometric%20cinematic%20composition%2C%20high%20detail%2C%20no%20text%20no%20letters%20no%20words&width=600&height=900&seq=mv-totoro-1988&orientation=portrait",
    tagline: "有些朋友，只有孩子才看得见。",
    summary: "搬到乡下的两姐妹遇见了森林里的神奇伙伴，度过了一个充满魔法的夏天。",
    synopsis:
      "为了方便照顾住院的母亲，大学教授带着两个女儿小月和小梅搬到了乡下的老房子。在这片被绿意包围的田野与森林里，年幼的小梅偶然遇见了传说中的森林精灵——一只巨大的、毛茸茸的龙猫。在龙猫的陪伴下，姐妹俩经历了一段温柔又奇妙的夏日时光。当小梅走失、一切都变得慌乱时，龙猫和它的伙伴们，用一场飞越夜空的旅程，让这个家庭重新找到温暖与勇气。",
    reviews: [
      {
        id: "r-tt-1",
        author: "森林散步者",
        rating: 5,
        text: "没有任何反派，却依然让人紧张又感动。它把童年的安全感拍成了一部电影。",
        date: "2024-05-01",
      },
      {
        id: "r-tt-2",
        author: "雨伞与公交站",
        rating: 5,
        text: "雨里那把伞，是全世界最温柔的一幅画。隔多久看一次，都还是想哭。",
        date: "2023-08-20",
      },
    ],
  },
  {
    id: "platoon-1986",
    title: "野战排",
    originalTitle: "Platoon",
    year: 1986,
    genres: ["战争", "剧情"],
    region: "欧美",
    director: "奥利弗·斯通",
    cast: ["查理·辛", "威廉·达福", "汤姆·贝伦杰"],
    runtime: 120,
    rating: 8.1,
    poster:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20war%20drama%20film%20poster%20illustration%20of%20soldier%20silhouettes%20wading%20through%20a%20misty%20jungle%20at%20dawn%20with%20glowing%20orange%20sky%2C%20tense%20mood%2C%20vintage%20film%20grain%20texture%2C%20deep%20teal%20and%20burnt%20orange%20palette%2C%20geometric%20cinematic%20composition%2C%20high%20detail%2C%20no%20text%20no%20letters%20no%20words&width=600&height=900&seq=mv-platoon-1986&orientation=portrait",
    tagline: "在战争里，敌人有时来自自己人。",
    summary: "一名理想主义的年轻士兵在越南战场上，目睹战友之间的道德分裂与人性挣扎。",
    synopsis:
      "怀揣报国理想的大学生克里斯自愿参军，被派往越南前线。在湿热危险的丛林里，他很快发现自己面对的不只是敌人，还有队伍内部的分裂：一面是坚守底线的中士伊莱亚斯，一面是冷酷暴戾的中士巴恩斯。当两人之间的矛盾逐渐演变为血腥的敌意，克里斯被迫在两种人性和两种选择之间做出自己的判断。战争的残酷，不只是枪炮，更是人心的裂痕。",
    reviews: [
      {
        id: "r-pl-1",
        author: "战地笔记",
        rating: 4.5,
        text: "斯通把自己亲历的战争拍得真实而沉重。它不歌颂胜利，只质问代价。",
        date: "2024-03-30",
      },
      {
        id: "r-pl-2",
        author: "丛林电台",
        rating: 4,
        text: "几场夜战戏拍得极具压迫感。它让人明白，战争从来没有干净的一方。",
        date: "2023-07-04",
      },
    ],
  },
];

export const featuredIds = [
  "back-to-the-future-1985",
  "blade-runner-1982",
  "the-terminator-1984",
  "a-better-tomorrow-1986",
  "my-neighbor-totoro-1988",
];

export const popularity: Record<string, number> = {
  "back-to-the-future-1985": 98,
  "blade-runner-1982": 88,
  "the-terminator-1984": 92,
  "e-t-1982": 90,
  "die-hard-1988": 94,
  "ghostbusters-1984": 84,
  "the-breakfast-club-1985": 76,
  "top-gun-1986": 89,
  "aliens-1986": 91,
  "the-shining-1980": 87,
  "scarface-1983": 85,
  "raiders-of-the-lost-ark-1981": 93,
  "ferris-bueller-1986": 79,
  "when-harry-met-sally-1989": 82,
  "rain-man-1988": 78,
  "a-better-tomorrow-1986": 95,
  "my-neighbor-totoro-1988": 97,
  "platoon-1986": 74,
};

export function getPopularity(id: string): number {
  return popularity[id] ?? 60;
}

export function getMovieById(id: string): Movie | undefined {
  return movies.find((m) => m.id === id);
}

export function getMoviesByIds(ids: string[]): Movie[] {
  return ids
    .map((id) => movies.find((m) => m.id === id))
    .filter((m): m is Movie => Boolean(m));
}